import type React from "react";
import type {
	GraphHighlightHandle,
	KnowledgeGraphVisualizationProps,
} from "@/features/graph/hooks/useKnowledgeGraphCanvasView";
import KnowledgeGraphCanvasView from "@/features/graph/hooks/useKnowledgeGraphCanvasView";

const KnowledgeGraphCanvas: React.FC<KnowledgeGraphVisualizationProps> = (props) => {
	return <KnowledgeGraphCanvasView {...props} />;
};

export type { GraphHighlightHandle, KnowledgeGraphVisualizationProps };

export default KnowledgeGraphCanvas;
